const defaultHeaders = () => {
    if (window.myNtucConfig.authToken) {
        return { Authorization: `Bearer ${window.myNtucConfig.authToken}` }
    } else {
        return undefined
    }
}

export default defaultHeaders